import { createContext, useContext } from "react";

/**
 * Theme lives in Layout, which persists across navigation. The phone home
 * screen replaces the site header with its own chrome and still needs the
 * toggle, so it reads the same state rather than keeping a second copy that
 * would drift out of sync with the header on every other route.
 */
export const ThemeContext = createContext({
  theme: "dark",
  toggleTheme: () => {},
});

export const useTheme = () => useContext(ThemeContext);
